import axios from "axios";
import { API_BASE } from "../../config/env";
import { useNavigate } from "react-router";
export const FETCH_GETAPPLICATIONS_FULFILLED = "FETCH_GETAPPLICATIONS_FULFILLED";
export const FETCH_GETAPPLICATIONS_REJECTED = "FETCH_GETAPPLICATIONS_REJECTED";
export const FETCH_GETAPPLICATIONS_PENDING = "FETCH_GETAPPLICATIONS_PENDING";

export function getApplications(pageSize,pageNumber) {
    const token = localStorage.getItem("accessToken")
    const user = JSON.parse(localStorage.getItem("user"))
    let userId
    if (user) {
        userId = user.id
    } else {
        localStorage.clear();
    }

    return (dispatch) => {
        dispatch({
            type: "FETCH_GETAPPLICATIONS",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/paging-application-patient?pageSize=${pageSize}&pageNumber=${pageNumber}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}



